module.exports = __webpack_public_path__ + "img/otamerica_pe_spanish_2023_certification_badge.b804a972.png";